import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandAcceptedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_ACCEPTED),
    nodeId: Number,
    originalText: String,
    summaryText: String,
    version: Literal(1),
  })
);

const AiShorthandAcceptedEventServerRuntype = AiShorthandAcceptedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandAcceptedBrowserEvent = Static<typeof AiShorthandAcceptedEventBrowserRuntype>;
type AiShorthandAcceptedServerEvent = Static<typeof AiShorthandAcceptedEventServerRuntype>;

const isAiShorthandAcceptedBrowserEvent = (
  obj: BaseEvent
): obj is AiShorthandAcceptedBrowserEvent => {
  return obj.event === 'AI Shorthand Accepted';
};

const isAiShorthandAcceptedServerEvent = (
  obj: BaseEvent
): obj is AiShorthandAcceptedServerEvent => {
  return obj.event === 'AI Shorthand Accepted';
};

export {
  isAiShorthandAcceptedBrowserEvent,
  isAiShorthandAcceptedServerEvent,
  AiShorthandAcceptedEventBrowserRuntype,
  AiShorthandAcceptedEventServerRuntype,
  type AiShorthandAcceptedBrowserEvent,
  type AiShorthandAcceptedServerEvent,
};
